import React, { FC } from 'react'

interface Props {
  clickReportCallback: (key: string) => void
  list: {
    key: string
    title: string
    text: string
    icon?: string
  }[]
}

const ReportCardList: FC<Props> = (props) => {
  const {
    clickReportCallback,
    list,
  } = props

  return (
    <div className="report_card_frame">
      {
        list.map((value, i) => (
          <div
            className="report_card"
            key={`report_list_${i + 0}`}
            onClick={() => clickReportCallback(value.key)}
            role="none"
          >
            <div className="image_area">
              <img src={value.icon} alt="" />
            </div>
            <div className="detail_area">
              <div className="title">
                {value.title}
              </div>
              <div className="text">
                {value.text}
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default ReportCardList
